import React from 'react';
import { StyledArrowWrapper } from './style';
import { EArrowDirection } from 'utils/enums';
import { RollingOfferArrow } from 'templates/RollingOffer/shared/components/Arrow';
import { motion } from 'framer-motion';
import { ARROW_HEIGHT_WIDTH } from '../MatchMastersRollingOffer';

interface IArrowWrapperProps {
  index: number;
  arrowColor: string;
  isHorizontalViewActive: boolean;
}

const mapArrowDirection: Record<number, EArrowDirection> = {
  [0]: EArrowDirection.RIGHT,
  [1]: EArrowDirection.DOWN,
  [2]: EArrowDirection.LEFT,
  [3]: EArrowDirection.DOWN,
};

export const ArrowWrapper: React.FC<IArrowWrapperProps> = ({
  index,
  arrowColor,
  isHorizontalViewActive,
}) => {
  const arrowHeight = isHorizontalViewActive ? 180 : 152;
  const height = index % 2 === 0 ? arrowHeight : ARROW_HEIGHT_WIDTH;
  const paddingLeft = index % 4 === 1 ? '50%' : '';
  const paddingRight = index % 4 === 3 ? '50%' : '';

  return (
    <motion.div
      layout
      key={index}
      className="arrow-motion"
      exit={{
        opacity: 0,
        transition: { delay: index * 0.04, duration: 0 },
      }}
    >
      <StyledArrowWrapper
        key={index}
        height={height}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
      >
        <RollingOfferArrow
          color={arrowColor}
          direction={mapArrowDirection[index % 4]}
        />
      </StyledArrowWrapper>
    </motion.div>
  );
};
